import * as React from 'react';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Avatar, IconButton, Chip, Tooltip, Typography } from '@mui/material';
import { colors } from '../../assets/utils/constants';
import { Box } from '@mui/system';
import { RemoveRedEye, Launch } from '@mui/icons-material';
import { useState } from 'react';
import moment from 'moment';
import { Link } from 'react-router-dom';
import CustomDialog from '../Dialogs/CustomDialog';
import ORGDetails from '../../pages/practicalTraining/components/ORGDetails';

// ######################## Table column #######################
const columns = [
    { id: 's_n', label: 'S/N', minWidth: 1, align: 'center' },
    { id: 'name', label: 'Student name' },
    { id: 'org', label: 'Attended org' },
    {
        id: 'start_date',
        label: 'Start date',
        align: 'left',
    },
    {
        id: 'finish_date',
        label: 'Finish date',
        align: 'left',
    },
    {
        id: 'status',
        label: 'On-training status',
        align: 'center',
    },
    {
        id: 'action',
        label: 'Action',
        align: 'center',
    },
];
function createData(s_n, name, org, start_date, finish_date, status, action) {
    return {
        s_n,
        name,
        org,
        start_date,
        finish_date,
        status,
        action,
    };
}

// ######################## USER CARD #######################
const UserCard = ({ applicant }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            borderRadius: 3,
            position: 'relative',
            overflow: 'hidden',
        }}
    >
        <Avatar
            src={applicant.profile_picture}
            sx={{
                width: 65,
                height: 65,
                mr: 2,
                p: 0.5,
                border: `1px dotted ${colors.info}`,
                background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor3})`,
                img: {
                    objectFit: 'cover',
                },
            }}
        />
        <Box>
            <Typography
                sx={{
                    fontSize: 16,
                    color: colors.info,
                    fontWeight: 'bold',
                    width: 130,
                }}
                noWrap
            >
                {`${applicant.first_name} ${applicant?.middle_name} ${applicant.last_name}`}
            </Typography>
            <Typography
                sx={{
                    fontSize: 13,
                    display: 'flex',
                    alignItems: 'center',
                    color: colors.info,
                    fontWeight: 'bold',
                    opacity: 0.8,
                }}
            >
                {applicant.reg_id}
            </Typography>
            <Typography
                sx={{
                    fontSize: 13,
                    display: 'flex',
                    alignItems: 'center',
                    color: colors.primary,
                    fontWeight: 'bold',
                    opacity: 0.8,
                }}
            >
                {applicant.section.section.name}
            </Typography>
        </Box>
    </Box>
);

// !###################### MAIN FUNC ########################
const PTApplicantTable3 = ({ applicants, height }) => {
    // ################# Comp State ###################
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [openDialog, setOpenDialogy] = useState(false);
    const [organizationDetails, setOrganizationDetails] = useState({});

    // ################# FUNC ###############
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
    };

    // ############### FUNC ##################
    // -> Dialogy closer
    const handleDialogOpen = (org) => {
        setOrganizationDetails(org);
        setOpenDialogy(true);
    };

    // -> Dialogy closer
    const handleDialogClose = () => {
        setOpenDialogy(false);
    };

    // ######################## TABLE ROW #######################
    const rows = applicants?.map((applicant, index) => {
        return createData(
            <Typography sx={{ fontSize: 18, fontWeight: 'bold', opacity: 0.6 }}>
                {++index}
            </Typography>,
            <UserCard applicant={applicant} />,
            <Typography
                component={'div'}
                sx={{
                    fontSize: 15,
                    fontWeight: 'bold',
                    opacity: 0.8,
                    color: colors.primary,
                }}
            >
                {applicant.currTraining.institute.organization_name}
                <Tooltip arrow title={'Organization details'}>
                    <IconButton
                        size="small"
                        color="info"
                        onClick={() => {
                            let org = applicant?.currTraining.institute;
                            handleDialogOpen(org);
                        }}
                        sx={{
                            background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                        }}
                    >
                        <Launch sx={{ fontSize: 15 }} />
                    </IconButton>
                </Tooltip>
            </Typography>,
            <Typography
                noWrap
                sx={{
                    fontSize: 12,
                    fontWeight: 'bold',
                    opacity: 0.8,
                    color: colors.success,
                    textAlign: 'center',
                }}
            >
                {moment(applicant.currTraining.start_date).format(
                    'MMM Do YYYY',
                )}
            </Typography>,
            <Typography
                noWrap
                sx={{
                    fontSize: 12,
                    fontWeight: 'bold',
                    opacity: 0.8,
                    color: 'red',
                    textAlign: 'center',
                }}
            >
                {moment(applicant.currTraining.finish_date).format(
                    'MMM Do YYYY',
                )}
            </Typography>,
            <Chip
                size="small"
                sx={{
                    textTransform: 'capitalize',
                    fontSize: 12,
                    fontWeight: 'bold',
                    px: 1,
                    opacity: 0.8,
                }}
                color={
                    applicant?.currTraining.onTrainingStatus === 'pending'
                        ? 'warning'
                        : applicant?.currTraining.onTrainingStatus ===
                          'completed'
                        ? 'success'
                        : applicant?.currTraining.onTrainingStatus ===
                          'on-training'
                        ? 'info'
                        : 'secondary'
                }
                label={applicant?.currTraining?.onTrainingStatus}
            />,
            //? #################### ACTION BUTTON #######################
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignContent: 'end',
                    textAlign: 'center',
                }}
            >
                <Tooltip title="Student details" arrow>
                    <Link to={`/students/${applicant.id}`}>
                        <IconButton color="info" variant="outlined">
                            <RemoveRedEye sx={{ fontSize: 18 }} />
                        </IconButton>
                    </Link>
                </Tooltip>
            </Box>,
        );
    });

    return (
        <React.Fragment>
            <CustomDialog
                head={'Student attended training organization details'}
                openDialog={openDialog}
                customWidth={'md'}
                handleDialogClose={handleDialogClose}
            >
                <ORGDetails organization={organizationDetails} />
            </CustomDialog>

            <Paper
                sx={{ width: '100%', overflow: 'hidden', boxShadow: 'none' }}
            >
                <TableContainer
                    sx={{
                        height: height ? height : '57.5vh',
                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                    }}
                >
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell
                                        key={column.id}
                                        align={column.align}
                                        sx={{
                                            textTransform: 'uppercase',
                                            fontWeight: 'bold',
                                            background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor3})`,
                                            fontSize: 12,
                                            color: colors.primary,
                                            whiteSpace: 'nowrap',
                                            opacity: 0.8,
                                        }}
                                        style={{ minWidth: column.minWidth }}
                                    >
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows
                                .slice(
                                    page * rowsPerPage,
                                    page * rowsPerPage + rowsPerPage,
                                )
                                .map((row, index) => {
                                    return (
                                        <TableRow
                                            hover
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={index}
                                            sx={{
                                                background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor2})`,
                                            }}
                                        >
                                            {columns.map((column) => {
                                                const value = row[column.id];
                                                return (
                                                    <TableCell
                                                        key={column.id}
                                                        align={column.align}
                                                    >
                                                        {column.format &&
                                                        typeof value ===
                                                            'number'
                                                            ? column.format(
                                                                  value,
                                                              )
                                                            : value}
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[1, 2, 5, 10]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    sx={{
                        background: `linear-gradient(180deg, ${colors.bgColor1}, ${colors.bgColor3})`,
                    }}
                />
            </Paper>
        </React.Fragment>
    );
};

export default PTApplicantTable3;
